import { CopyIcon } from "@chakra-ui/icons";
import { MenuItem, MenuItemProps } from "@chakra-ui/react";
import { assertPresence } from "utils/assertions";
import { asyncVoid } from "utils/asyncVoidHandler";

type Props = Omit<MenuItemProps, "value"> & {
  value: string | null | undefined;
};

export default function CopyMenuItem({
  children = "Copy",
  isDisabled,
  value,
  ...rest
}: Props) {
  return (
    <MenuItem
      icon={<CopyIcon />}
      isDisabled={!value || !!isDisabled}
      onClick={(e) => {
        e.stopPropagation();
        assertPresence(value, "Expected value to be present");
        asyncVoid(navigator.clipboard.writeText(value));
      }}
      {...rest}
    >
      {children}
    </MenuItem>
  );
}
